<template>
  <div>
    <Application :uuid="uuid" @success="success" />
  </div>
</template>

<script>
import Application from '@/components/woori-crowd/Application.vue'
export default {
  components: { Application },
  props: {
    uuid: {
      type: String,
    },
  },
  created() {
    _meta({
      titles: ['회원가입', '우리동네크라우드참여신청서'],
    })
  },
  methods: {
    async success() {
      await this.$router.replace('/factoring/success')
    },
  },
}
</script>
